import { css, styled, Table } from "@lux/ds";

export const StyledTable = styled(Table)(
  ({ theme }) => css`
    border: 1px solid ${theme.palette.primary.shade[85]};

    & .MuiTableHead-root {
      background-color: ${theme.palette.common.white};

      .MuiTableCell-root {
        font-weight: bold;
      }
    }

    & .MuiTableBody-root {
      .MuiTableRow-root {
        border-bottom: 1px solid ${theme.palette.primary.shade[85]};

        &:nth-of-type(even) {
          background: ${theme.palette.primary.shade[98]};
        }
      }
    }
  `,
);
